import { twMerge } from 'tailwind-merge';
import List from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import type { DateTimePreset } from '../types';
import { classes } from './utils';

export type PresetsListProps = {
  className?: string;
  presets: DateTimePreset[];
  onSelect: (preset: DateTimePreset) => void;
};

export default function PresetsList({
  className,
  presets,
  onSelect,
}: PresetsListProps) {
  return (
    <List className={twMerge(classes.list, className)}>
      {presets.map((preset) => (
        <MuiListItem
          key={preset.label}
          className={classes.listItem}
          onClick={() => onSelect(preset)}>
          <ListItemText className={classes.text} primary={preset.label} />
        </MuiListItem>
      ))}
    </List>
  );
}
